// extracted by mini-css-extract-plugin
export default {"input":"AddToDo_input__P1i-9","select":"AddToDo_select__calkq"};